<p-checkbox
  [styleClass]="invalidStyleClass"
  [name]="name()"
  [value]="binary ? null : value"
  [tabindex]="tabindex"
  [inputId]="checkboxInputId"
  [ariaLabelledBy]="ariaLabelledBy"
  [ariaLabel]="ariaLabel"
  [required]="required()"
  [binary]="binary"
  [(ngModel)]="boundModel"
  (onChange)="onChange.emit($event)"
  [indeterminate]="showDashedIcon"
  [disabled]="$disabled()">
</p-checkbox>
<label
  [for]="checkboxInputId"
  class="m-checkbox-label"
  [class.m-checkbox-label-checked]="isChecked && !error"
  [class.m-checkbox-label-error]="error">
  <ng-content></ng-content>
</label>
